import { APIClient } from '@convergence/client';

export const client = new APIClient(
  import.meta.env.VITE_API_ENDPOINT as string,
  import.meta.env.VITE_SUBSCRIPTION_ENDPOINT as string
);
